module.exports = __webpack_public_path__ + "img/icon_game.132a13e1.svg";